"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var lodash_1 = require("lodash");
var axios_client_config_const_1 = require("./axios-client.config.const");
/**
 * AxiosClientConfigService
 * @class
 * @private
 */
var AxiosClientConfigService = /** @class */ (function () {
    function AxiosClientConfigService() {
    }
    AxiosClientConfigService.prototype.init = function (config, customHeaders) {
        if (customHeaders === void 0) { customHeaders = {}; }
        var token = (config || '').token;
        var baseUrl = config.host || axios_client_config_const_1.axiosConfig.baseURL;
        axios_1.default.defaults.baseURL = baseUrl;
        axios_1.default.defaults.timeout = axios_client_config_const_1.axiosConfig.timeout;
        axios_1.default.defaults.headers = tslib_1.__assign({}, customHeaders, {
            Authorization: token,
        });
        if (!lodash_1.isNull(config.apikey)) {
            axios_1.default.defaults.headers.apiKey = config.apikey || axios_client_config_const_1.apigeeConfig.apikey;
        }
    };
    return AxiosClientConfigService;
}());
exports.axiosClientConfig = new AxiosClientConfigService();
